/** @jsxImportSource @emotion/react */
import React from 'react';
import { Button, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { css } from '@emotion/react';

const CreateVideo = ({ onClick, onClickStartFromScratch }) => {
  return (
    <Space direction='horizontal'>
    <Button
      type="primary"
      onClick={onClick}
      css={css`
        border-radius: 20px;
        display: flex;
        align-items: center;
        gap: 8px;
      `}
    >
      <PlusOutlined />
      Create new
      <span
        css={css`
          background: rgba(255, 255, 255, 0.2);
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 12px;
          margin-left: 4px;
        `}
      >
        AI
      </span>
    </Button>
    <Button
    size='medium'
      css={css`
        border-radius: 20px;
        display: flex;
        align-items: center;
        gap: 8px;
      `}
      onClick={onClickStartFromScratch}
    
    >
      <PlusOutlined />
        Start from scratch
    </Button> 
    </Space>

  );
};

export default CreateVideo;